import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { useFormikContext } from "formik";
import React from "react";

import CurrencyInput from "@/components/atoms/CurrencyInput";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { ListPriceFormData } from "@/components/screens/ListPriceFormPage/types";
import { ListPriceFormMessages } from "@/messages/listPrice/list-price-form.messages";

type Props = {
  messages: ListPriceFormMessages;
};

function ValuesSection({ messages }: Props) {
  const { values, handleChange, setFieldValue, errors } = useFormikContext<ListPriceFormData>();

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox p={3}>
        <MDBox display="flex" justifyContent="space-between">
          <MDTypography variant="h5" fontWeight={"bold"}>
            {messages.pricingGroupTitle}
          </MDTypography>
        </MDBox>

        <MDBox mt={1}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <CurrencyInput
                name="mainPrice"
                label={messages.priceLabel}
                value={values.mainPrice}
                onChange={handleChange}
                fullWidth
                error={!!errors.mainPrice}
                helperText={errors.mainPrice}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <DatePicker
                label={messages.promotionStartLabel}
                value={dayjs(values.startPromoPrice)}
                onChange={(value) => setFieldValue("startPromoPrice", value)}
                slotProps={{
                  textField: {
                    helperText: errors.startPromoPrice as string,
                    error: !!errors.startPromoPrice,
                    fullWidth: true,
                    variant: "standard",
                    InputLabelProps: { shrink: true },
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <DatePicker
                label={messages.promotionEndLabel}
                value={dayjs(values.endPromoPrice)}
                onChange={(value) => setFieldValue("endPromoPrice", value)}
                slotProps={{
                  textField: {
                    error: !!errors.endPromoPrice,
                    helperText: errors.endPromoPrice as string,
                    fullWidth: true,
                    variant: "standard",
                    InputLabelProps: { shrink: true },
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <CurrencyInput
                name="promoPrice"
                label={messages.promotionalPriceLabel}
                value={values.promoPrice}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
                error={!!errors.promoPrice}
                helperText={errors.promoPrice}
              />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default ValuesSection;
